<template lang="pug">
  vm-row(vm-w="12" vm-type="flex" vm-justify="space-between" class="information__wrapper")
    vm-col(vm-sm=12 vm-md=6 vm-lg=8 class="gutters")
      .card
        .card-body
          vm-row(vm-w="12" vm-type="flex" vm-justify="space-between" class="p-0 h-100")
            vm-col(vm-sm=12 vm-md=12 vm-lg=4 class="p-0 h-100")
              .flex-column.border-right
                vm-row(vm-w="12" vm-type="flex" vm-justify="left" class="p-0")
                  span.detail_sale.text-center.text-lg-left Detalles de la venta
                vm-row(vm-w="12" vm-type="flex" vm-justify="left" class="p-0")
                  span.text-center.seller-title.text-lg-left Vendedor
                vm-row(vm-w="12" vm-type="flex" vm-justify="left" class="p-0")
                  h3.seller__wrapper__name.text-center.text-lg-left {{ created_by }}
            vm-col(vm-sm=12 vm-md=12 vm-lg=3 class="p-0 h-100")
              .card-body
                h4 IMPORTE BRUTO
                h3  {{ gross_amount | currency }}
            vm-col(vm-sm=12 vm-md=12 vm-lg=3 class="p-0 h-100")
              .card-body
                h4 % UTILIDAD
                h3  {{ utility_percent }}
    vm-col(vm-sm=12 vm-md=6 vm-lg=4 class="gutters")
      .card
        .card-body
          vm-row(vm-w="12" vm-type="flex" vm-justify="space-between" class="p-0")
            h4 Detalles de la moneda
          vm-row(vm-w="12" vm-type="flex" vm-justify="space-between" class="p-0")
            vm-col(vm-sm=6 vm-md=6 vm-lg=6 class="p-0 h-100")
              .card-body
                h4.text-primary Tipo de Cambio
                h3  {{ exchange_rate | currency }}
            vm-col(vm-sm=6 vm-md=6 vm-lg=6 class="p-0 h-100")
              .card-body
                h4.text-primary Moneda
                h3  {{ currency_code }}
</template>

<script>
export default {
  name: 'SaleDetailInformation',
  props: {
    sale: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    created_by () {
      if (this.sale.created_by) {
        return this.sale.created_by.name
      } else {
        return this.$t('sale.error')
      }
    },
    gross_amount () {
      if (this.sale.quotation.subtotal) {
        return this.sale.quotation.subtotal
      } else {
        return this.$t('sale.error')
      }
    },
    utility_percent () {
      if (this.sale.utility_percent) {
        return `${parseFloat(this.sale.utility_percent).toFixed(2)} %`
      } else {
        return '0.00 %'
      }
    },
    currency_code () {
      if (this.sale.currency.code) {
        return this.sale.currency.code
      } else {
        return this.$t('sale.error')
      }
    },
    exchange_rate () {
      if (this.sale.quotation.exchange_rate) {
        return this.sale.quotation.exchange_rate
      } else {
        return this.$t('sale.error')
      }
    }
  }
}
</script>

<style lang="scss">
.information__wrapper {
  margin-top: 25px;
  .card {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px !important;
    height: 100% !important;
    .card-body {
      padding: 10px !important;
      width: 100%;
      height: 100%;
      .icon__wrapper {
        padding: 10px !important;
        border-radius: 0.5em;
        background-color: #dfdfdf;
      }
      span.detail_sale {
        font-size: 20px;
        font-weight: 600;
      }
      h3.seller__wrapper__name {
        width: 100%;
        font-size: 20px !important;
      }
      span {
        width: 100%;
      }
      span.subtitle {
        font-size: 16px;
        font-weight: bold;
      }
      span.seller-title {
        font-size: 16px;
        font-weight: bold;
        color: #0082aa;
      }
    }
  }
}

/* Globales */
h4 {
  text-align: center;
  margin-bottom: 1rem;
  font-weight: 200;
  font-size: 1.1rem;
}
h3 {
  text-align: center;
  font-weight: bold;
  font-size: 1.3rem;
}

/* Helpers */
.text-center {
  text-align: center !important;
}

.gutters {
  padding: 20px;
}
.h-100 {
  height: 100%;
}

.p-0 {
  padding: 0 !important;
}

.flex-column {
  padding: 0 !important;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-content: space-between;
  justify-content: space-between;
}

@media screen and (min-width: 992px) {
  .border-right {
    border-right: 1px solid #a8a8a8;
  }
  .text-lg-left {
    text-align: left !important;
  }
}

.text-primary {
  color: #0082aa;
}
</style>
